// Copyright 2024 praveen.konathala
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { FilterState } from 'src/slices/filterSlice';
import { RootState } from '../store';
export const selectChannelKeys = (state: { filters: FilterState }) =>
  state.filters.channels ? Object.keys(state.filters.channels) : [];
export const selectMachineTypeKeys = (state: { filters: FilterState }) =>
  state.filters.machineTypes ? Object.keys(state.filters.machineTypes) : [];
export const selectPlanogramKeys = (state: { filters: FilterState }) =>
  state.filters.planograms ? Object.keys(state.filters.planograms) : [];
export const selectChannels = (state: RootState) => state.filters.channels;
export const selectMachineTypes = (state: RootState) =>
  state.filters.machineTypes;
export const selectPlanograms = (state: RootState) => state.filters.planograms;
export const selectLocations = (state: RootState) => state.filters.locations;
export const selectProducts = (state: RootState) => state.filters.products;
export const selectProductKeys = (state: RootState) =>
  state.filters.products ? Object.keys(state.filters.products) : [];
export const selectStores = (state: RootState) => state.filters.stores;
export const selectLocationKeys = (state: { filters: FilterState }) =>
  state.filters.locations ? Object.keys(state.filters.locations) : [];
export const selectLoadingStatus = (state: RootState) => state.filters.loading;
export const selectError = (state: RootState) => state.filters.error;
export const selectSelectedFilter = (state: RootState) =>
  state.filters.selectedFilter;
export const selectSelectedBrand = (state: RootState) =>
  state.filters.selectedFilter.account;
export const selectSelectedClientConfig = (state: RootState) =>
  state.filters.clientConfig;
export const selectClientType = (state: RootState) => state.filters.clientType;

export const selectStartDate = (state: RootState) =>
  state.filters.selectedFilter.start;
export const selectAggregation = (state: RootState) =>
  state.filters.selectedFilter.aggregation;
export const selectFilterAccount = (state: RootState) =>
  state.filters.selectedFilter.account;

export const selectEndDate = (state: RootState) =>
  state.filters.selectedFilter.end;
export const selectTimeStamp = (state: RootState) =>
  state.filters.selectedFilter.timeStamp;
export const selectShowTable = (state: RootState) => state.filters.showTable;
export const selectisExportToCsv = (state: RootState) =>
  state.filters.isExportToCsv;
export const selectLoader = (state: RootState) => state.filters.loading;
export const selectShowTrendLine = (state: RootState) =>
  state.filters.showTrendLine;

//can remove if not used anywhere////
export const selectAlertId = (state: RootState) =>
  state.filters.selectedFilter.alertId;
export const selectTicketType = (state: RootState) =>
  state.filters.selectedFilter.ticketType;
export const selectPriority = (state: RootState) =>
  state.filters.selectedFilter.priority;
//////////////////////////////
// export const selectStoreId = (state: RootState) =>
//   state.filters.selectedFilter.storeId;
export const allStoreDetails = (state: RootState) =>
  state.filters.storeIdDetails;

export const filtersData = (state: RootState) => state.filters;
